import { ReactComponent as News } from 'assets/icons/icon-news.svg';

export default News;
